import { DOCUMENT } from '@angular/common'
import { ApplicationRef, ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit, Renderer2, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { BehaviorSubject, interval } from 'rxjs'
import { switchMap, first, } from 'rxjs/operators'
import { environment } from 'src/environments/environment'
import { AppName } from 'src/environments/environment-d'
import { AmplitudeService } from './analytics/amplitude.service'
import { LanguagesService } from './lang/languages.service'


@Component({
  selector: 'tpr-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
  webreadyFeatureImageIndex$ = new BehaviorSubject(1); // (4);
  rategenieFeatureImageIndex$ = new BehaviorSubject(1); // (7);
  ownersFeatureImageIndex$ = new BehaviorSubject(1); // (6);

  constructor(
    @Inject(DOCUMENT) document: Document,
    private appRef: ApplicationRef,
    private cd: ChangeDetectorRef,
    renderer: Renderer2,
    route: ActivatedRoute,
    amp: AmplitudeService,
    private translate: TranslateService,
    private languagesService: LanguagesService,
    // @Inject('APP_NAME') public appName: AppName, // APP_NAME relies on routing. not available outside of <router-outlet>
  ) {
    // NOTE: REQUEST and RESPONSE injection token are not available during prerendering
    // here we use query parameter ?app=<checklist|tokeet|...>
    //
    // 1. for build-time app values are specified in angular.json/prerender/options/routes
    // 2. for run-time app values are added using nginx configs (mapping domains to app parameter)
    //
    route.queryParams.subscribe(params => {
      const appName: AppName = params.app
      if (!appName) return
      const app = environment.apps[appName]
      const favicon = document.getElementById('favicon') as HTMLLinkElement
      favicon.href = app.faviconUrl
      renderer.addClass(document.body, app.theme)
      renderer.setAttribute(document.body, 'data-app', appName)
      if (app.amplitudeKey) {
        amp.init(app.amplitudeKey)
      }
    })
    // SSR Note: https://angular.io/api/core/ApplicationRef#isstable-examples-and-caveats
    this.appRef.isStable.pipe(
      first(stable => stable),
      switchMap(() => interval(3000))
    ).subscribe(counter => {
      this.webreadyFeatureImageIndex$.next((counter % 4) + 1)
      this.rategenieFeatureImageIndex$.next((counter % 7) + 1)
      this.ownersFeatureImageIndex$.next((counter % 6) + 1)
      this.cd.detectChanges();
    });
  }

  ngOnInit() {
    this.translate.use(this.languagesService.getUserLanguage());
  }
}
